<transaction-list-header-template
  (closeEmitter)="closeEmitter?.emit()"
  [activity]="activity"
  [canOpen]="canOpen"
  [transaction]="transaction">
  <ng-container symbol>
    <ng-container>
      <img
        class="image-size"
        [src]="getIconCurrency()?.getLogo()"
        (error)="img.src = '/assets/images/default-asset.svg'"
        alt="{{ 'logo_alt_text' | translate }}"
        #img />
    </ng-container>
  </ng-container>
  <ng-container status>
    @if (isTransactionPending || isSEPAWithdrawProcessing()) {
      <span class="information-header-dot"></span>
    }
    @if (!hasTrade() && !isDebitCardTx()) {
      @if (isIncomingTransfer()) {
        {{ "received_internal_send" | translate: [currencySymbol] }}
      }
      @if (isOutgoingTransfer()) {
        {{ "sent_internal_send" | translate: [currencySymbol] }}
      }
      @if (isCardOrderingFee()) {
        {{ "transaction_details_subtitle_reorder_charge" | translate: [currencySymbol] }}
      }
      @if (transaction?.isRefund()) {
        <span class="pr-5">{{ "refund_tx_type" | translate: [currencySymbol] }}</span>
      }
      @if (transaction?.getType() !== 'transfer' && !transaction?.isRefund() && !isCardOrderingFee()) {
        {{ currencySymbol }} {{ (isFiatSend() ? "send" : transaction?.getType()) + "_tx_type" | translate }}
      }
    }
    @if (isDebitCardTx() && !isCardOrderingFee()) {
      {{
      (transaction?.isWithdrawal() ? "debit_card_tx_header_title" : "refund_tx_type")
      | translate: [currencySymbol]
      }}
    }
    @if (isCardOrderingFee()) {
      {{ "transaction_details_subtitle_reorder_charge" | translate: [currencySymbol] }}
    }
  </ng-container>
  <ng-container transaction>
    <div class="recipient-information" [ngClass]="{ isOpen: !canOpen }">
      @if (transaction?.isType('deposit')) {
        {{ "from" | translate }}: {{ getPaymentProvider()?.getName() }}
      }
      @if (transaction?.isType('withdrawal') && !isDebitCardTx() && !isCardOrderingFee()) {
        {{ "to" | translate }}:
        @if (transaction?.hasBankAccountDetails) {
          {{ transaction.getBankAccountDetails().getBankName() }}
        }
        @if (!transaction?.hasBankAccountDetails) {
          @if (!isBankTransfer()) {
            <span>
              {{ getPayoutProvider()?.getName() }}
            </span>
          }
          @if (isBankTransfer()) {
            <span>{{ getBankName() }}</span>
          }
        }
      }
      @if (transaction?.isTransfer() || transaction?.getType() === 'refund') {
        <span>{{ getRecipientPrefix() | translate }}: {{ getRecipientInformation() }}</span>
      }
    </div>
  </ng-container>

  <!--CHANGE-->
  <ng-container amounts>
    <div
      class="amount"
      [ngClass]="{ 'is-uncredited': isUncredited() }"
      hidePortfolioValue
      [isHideActive]="isWidget && (isHideValueActive$ | async)">
      <div
        class="amount-main"
				[ngClass]="{
					'is-cancelled': transaction?.isStatus('canceled'),
					isOpen: !canOpen,
					'price-up': !transaction?.isOutgoing()
				}">
        <ng-container>
          {{
          amount
          | fiat_precision_symbol
          : {
          id: fiatForAmount?.getId(),
          prefix: amount === 0,
          symbol: true,
          currencies: [fiatForAmount]
        }
        | value_change_prefix: { isProfit: !transaction?.isOutgoing(), noChange: amount === 0 }
        }}
      </ng-container>
    </div>
  </div>
</ng-container>
<ng-container amountsExchanged>
  @if (!isDebitCardTx()) {
    <div
      class="amount"
      [ngClass]="{ 'is-uncredited': isUncredited() }"
      hidePortfolioValue
      [isHideActive]="isWidget && (isHideValueActive$ | async)">
      @if (transaction?.hasTrade()) {
        <div
          class="amount-exchanged"
				[ngClass]="{
					'is-cancelled': transaction?.isStatus('canceled'),
					isOpen: !canOpen
				}"
          >
          <ng-container>
            {{
            getCryptoAmountFromTrade()
            | tradable_precision_symbol
            : {
            id: getCurrencyId(),
            ignorePrecision: !canOpen
          }
          }}
        </ng-container>
      </div>
    }
  </div>
}
</ng-container>
</transaction-list-header-template>
